import theme from '@styles/theme';
export default {
  linkedSection: (isArticles?: boolean) => ({
    bg: isArticles ? theme.rawColors.beige500 : theme.rawColors.neutralWhite,
    pt: [48, 48, isArticles ? 80 : 64, 116],
    h2: {
      pl: [40, 40, 64, '10.15625vw']
    }
  }),
  productBox: {
    maxWidth: '442px',
    width: ['154px', '154px', '154px', '23.64583vw'],
    height: '100%',
    display: 'flex'
  }
};